(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["minimal-cart-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
    const content = drawer.querySelector('[data-cart-content]');
    const recommendations = JSON.parse(drawer.querySelector('[data-cart-recommendations]')?.textContent || '[]');
    const root = window.Shopify?.routes?.root || '/';
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      currency: currency || 'USD',
      currencyDisplay: 'symbol',
      style: 'currency'
    }).format(amount / 100);
    const decodeHtml = (value) => {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = String(value || '');
      return textarea.value;
    };
    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
    })[character]);
    const shippingGoal = Math.max(0, Number(drawer.dataset.freeShippingGoal || 0)) * 100;
    let latestCart;
    let lastTrigger;
    let recommendationsCollapsed = false;
    let cartBusy = false;
    let cartLoadFailed = false;
    let refreshPromise;
    let refreshQueued = false;
    const status = drawer.querySelector('[data-cart-status]');
    let sizeModule;
    const loadSizeModule = () => sizeModule || (sizeModule = import(drawer.dataset.sizeModule).catch((error) => { sizeModule = null; throw error; }));
    const products = new Map();
    const editableSize = (item) => !item.selling_plan_allocation && !item.parent_relationship && !item.item_components?.length
      && (item.options_with_values || []).some((option) => ['size', 'sizes', 'размер', 'розмір', 'talla', 'taille', 'größe', 'taglia', 'tamanho', 'サイズ'].includes(String(option.name).trim().toLowerCase()));
    const setBusy = (busy) => {
      cartBusy = busy;
      drawer.setAttribute('aria-busy', String(busy));
      content.querySelectorAll('button:not([data-cart-close]), select').forEach((control) => { control.disabled = busy || control.dataset.sizeUnavailable === 'true' || (cartLoadFailed && !control.matches('[data-cart-retry]')); });
      const checkout = content.querySelector('.minimal-cart-drawer__checkout');
      if (checkout) {
        checkout.setAttribute('aria-disabled', String(busy || cartLoadFailed));
        checkout.tabIndex = busy || cartLoadFailed ? -1 : 0;
      }
    };

    const recommendationMarkup = (cart) => {
      const cartProductIds = new Set(cart.items.map((item) => item.product_id));
      const available = recommendations.filter((product) => product.available && !cartProductIds.has(product.id)).slice(0, 5);
      if (!available.length) return '';

      return `
        <section class="minimal-cart-drawer__recommendations${recommendationsCollapsed ? ' is-collapsed' : ''}">
          <button class="minimal-cart-drawer__recommendations-title" type="button" data-recommendations-toggle aria-expanded="${String(!recommendationsCollapsed)}">${escapeHtml(drawer.dataset.recommendationsLabel)}</button>
          <div class="minimal-cart-drawer__recommendations-grid">
            ${available.map((product) => `
              <article>
                <a class="minimal-cart-drawer__recommendation-image" href="${escapeHtml(product.url)}">
                  ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
                </a>
                <a class="minimal-cart-drawer__recommendation-title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
                <span class="minimal-cart-drawer__recommendation-price">${money(product.price, cart.currency)}</span>
                ${product.hasSingleVariant && !product.isPreorder ? `<button class="minimal-cart-drawer__recommendation-action" type="button" data-recommendation-add="${product.variantId}">${escapeHtml(drawer.dataset.addLabel)}</button>` : `<a class="minimal-cart-drawer__recommendation-action" href="${escapeHtml(product.url)}">${escapeHtml(drawer.dataset.viewLabel)}</a>`}
              </article>
            `).join('')}
          </div>
        </section>
      `;
    };

    const itemMarkup = (item, cart) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="minimal-cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : '';
      const properties = Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && typeof value === 'string' && value)
        .map(([key, value]) => `<p class="minimal-cart-drawer__item-variant">${escapeHtml(key)}: ${escapeHtml(value)}</p>`).join('');
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
      const removeLabel = drawer.dataset.removeLabel.replace('__product__', item.product_title);
      return `
        <article class="minimal-cart-drawer__item" data-cart-line="${escapeHtml(item.key)}">
          <a class="minimal-cart-drawer__image" href="${escapeHtml(item.url)}">${image}</a>
          <div>
            <a class="minimal-cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}
            ${editableSize(item) ? `<button type="button" class="minimal-cart-drawer__size-edit" data-cart-edit-size="${escapeHtml(item.key)}" aria-expanded="false">${escapeHtml(drawer.dataset.sizeEdit)}</button><div data-cart-size-editor></div>` : ''}
            ${properties}
            <p class="minimal-cart-drawer__item-price">${money(item.final_line_price, cart.currency)}</p>
          </div>
          <div class="minimal-cart-drawer__quantity">
            <button class="minimal-cart-drawer__quantity-button" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="${escapeHtml(drawer.dataset.decreaseLabel)}">−</button>
            <span>${item.quantity}</span>
            <button class="minimal-cart-drawer__quantity-button" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="${escapeHtml(drawer.dataset.increaseLabel)}">+</button>
            <button class="minimal-cart-drawer__remove" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0" aria-label="${escapeHtml(removeLabel)}">×</button>
          </div>
        </article>
      `;
    };

    const render = (cart) => {
      latestCart = cart;
      cartLoadFailed = false;
      if (!cart.item_count) {
        content.innerHTML = `<div class="minimal-cart-drawer__state"><p class="minimal-cart-drawer__empty">${escapeHtml(drawer.dataset.emptyLabel)}</p><a class="minimal-cart-drawer__continue" href="${escapeHtml(root)}?catalog=1">${escapeHtml(drawer.dataset.continueLabel)}</a></div>`;
        return;
      }

      const remaining = Math.max(0, shippingGoal - cart.total_price);
      const progress = shippingGoal ? Math.min(100, (cart.total_price / shippingGoal) * 100) : 0;
      const shipping = shippingGoal ? (remaining ? decodeHtml(drawer.dataset.awayLabel).replace('__amount__', money(remaining, cart.currency)) : decodeHtml(drawer.dataset.freeShippingLabel)) : '';
      content.innerHTML = `
        ${shippingGoal ? `<p class="minimal-cart-drawer__shipping">${escapeHtml(shipping)}</p><div class="minimal-cart-drawer__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><span class="minimal-cart-drawer__progress-fill" style="width:${progress}%"></span></div>` : ''}
        <div class="minimal-cart-drawer__items">${cart.items.map((item) => itemMarkup(item, cart)).join('')}</div>
        <div class="minimal-cart-drawer__footer">
          <span class="minimal-cart-drawer__total-label">${escapeHtml(drawer.dataset.totalLabel)}</span>
          <span class="minimal-cart-drawer__total-price">${money(cart.total_price, cart.currency)}</span>
          <a class="minimal-cart-drawer__checkout" href="${root}checkout">${escapeHtml(drawer.dataset.checkoutLabel)}</a>
          <button class="minimal-cart-drawer__keep-shopping" type="button" data-cart-close>${escapeHtml(drawer.dataset.continueLabel)}</button>
        </div>
        ${recommendationMarkup(cart)}
      `;
    };

    const getCart = async () => {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) throw new Error('Unable to load cart');
        const cart = await response.json();
        if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0 || !Array.isArray(cart.items) || (cart.item_count === 0) !== (cart.items.length === 0) || !Number.isFinite(cart.total_price) || cart.total_price < 0) throw new Error('Invalid cart response');
        render(cart);
        return cart;
      } finally { window.clearTimeout(timeout); }
    };

    const refreshCart = (restoreFocus = false) => {
      if (refreshPromise) return refreshPromise;
      if (cartBusy) return Promise.resolve();
      content.querySelector('[data-cart-load-error]')?.remove();
      if (!latestCart) content.innerHTML = `<div class="minimal-cart-drawer__state"><p class="minimal-cart-drawer__state-copy" role="status">${escapeHtml(drawer.dataset.loadingLabel)}</p></div>`;
      status.textContent = latestCart ? drawer.dataset.loadingLabel : '';
      setBusy(true);
      refreshPromise = getCart().then(() => {
        status.textContent = '';
      }).catch(() => {
        cartLoadFailed = true;
        const message = latestCart ? drawer.dataset.loadCached : drawer.dataset.loadError;
        const markup = `<div class="minimal-cart-drawer__state${latestCart ? ' minimal-cart-drawer__state--cached' : ''}" data-cart-load-error><h2 class="minimal-cart-drawer__state-title">${escapeHtml(drawer.dataset.loadErrorHeading)}</h2><p class="minimal-cart-drawer__state-copy" role="alert">${escapeHtml(message)}</p><div class="minimal-cart-drawer__state-actions"><button class="minimal-cart-drawer__state-action minimal-cart-drawer__state-action--primary" type="button" data-cart-retry>${escapeHtml(drawer.dataset.retryLabel)}</button><a class="minimal-cart-drawer__state-action" href="${escapeHtml(root)}cart">${escapeHtml(drawer.dataset.pageLabel)}</a></div></div>`;
        if (latestCart) content.insertAdjacentHTML('afterbegin', markup);
        else content.innerHTML = markup;
        status.textContent = '';
      }).finally(() => {
        refreshPromise = null;
        setBusy(false);
        if (restoreFocus && !drawer.hidden && !drawer.inert) content.querySelector('[data-cart-retry], .minimal-cart-drawer__item-title, .minimal-cart-drawer__continue')?.focus({ preventScroll: true });
        if (refreshQueued) {
          refreshQueued = false;
          if (!drawer.hidden && !drawer.inert) refreshCart();
        }
      });
      return refreshPromise;
    };

    let closeTimer;
    let openFrame;
    let savedOverflow = '';

    const close = () => {
      if (drawer.hidden || drawer.inert) return;
      window.clearTimeout(closeTimer);
      window.cancelAnimationFrame(openFrame);
      drawer.classList.remove('is-open');
      drawer.inert = true;
      drawer.setAttribute('aria-hidden', 'true');
      const finish = () => {
        drawer.hidden = true;
        document.documentElement.style.overflow = savedOverflow;
        const trigger = lastTrigger?.isConnected && !lastTrigger.disabled ? lastTrigger : document.querySelector('[data-cart-trigger]');
        trigger?.focus({ preventScroll: true });
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else {
        const duration = parseFloat(getComputedStyle(drawer).getPropertyValue('--minimal-motion-panel')) || 260;
        closeTimer = window.setTimeout(finish, duration);
      }
    };

    const open = async (trigger) => {
      if (!drawer.hidden && !drawer.inert) {
        if (refreshPromise) refreshQueued = true;
        else if (!cartBusy) await refreshCart();
        return;
      }
      window.clearTimeout(closeTimer);
      window.cancelAnimationFrame(openFrame);
      if (drawer.hidden) savedOverflow = document.documentElement.style.overflow;
      lastTrigger = trigger || document.activeElement;
      drawer.hidden = false;
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      void drawer.offsetWidth;
      openFrame = window.requestAnimationFrame(() => drawer.classList.add('is-open'));
      drawer.querySelector('.minimal-cart-drawer__close')?.focus({ preventScroll: true });
      await refreshCart();
    };

    drawer.querySelectorAll('[data-cart-close]').forEach((control) => control.addEventListener('click', close));
    document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => trigger.addEventListener('click', (event) => { event.preventDefault(); open(trigger); }));
    window.addEventListener('minimal:cart-open', () => open());
    window.addEventListener('minimal:cart-updated', (event) => {
      if (event.detail?.added && drawer.dataset.openAfterAdding === 'true') {
        open(event.detail.trigger);
        return;
      }
      if (drawer.hidden || drawer.inert) return;
      if (refreshPromise) refreshQueued = true;
      else if (!cartBusy) refreshCart();
    });
    document.addEventListener('keydown', (event) => {
      if (drawer.hidden || drawer.inert) return;
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      const panel = drawer.querySelector('.minimal-cart-drawer__panel');
      const controls = [...panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
        .filter((control) => !control.disabled && control.tabIndex >= 0 && !control.closest('[inert]') && control.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      const outside = !panel.contains(document.activeElement);
      if (first && (outside || (event.shiftKey ? document.activeElement === first : document.activeElement === last))) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      }
    });

    content.addEventListener('click', async (event) => {
      if (event.target.closest('[data-cart-close]')) {
        event.preventDefault();
        close();
        return;
      }
      if (cartBusy) { event.preventDefault(); return; }
      if (event.target.closest('[data-cart-retry]')) {
        event.preventDefault();
        await refreshCart(true);
        return;
      }
      if (cartLoadFailed && event.target.closest('.minimal-cart-drawer__checkout')) { event.preventDefault(); return; }
      const editSize = event.target.closest('[data-cart-edit-size]');
      const sizeChoice = event.target.closest('[data-cart-size-value]');
      if (editSize) {
        const item = latestCart?.items.find((line) => line.key === editSize.dataset.cartEditSize);
        if (!item) return;
        const panel = editSize.parentElement.querySelector('[data-cart-size-editor]');
        if (editSize.getAttribute('aria-expanded') === 'true') {
          panel.replaceChildren();
          editSize.setAttribute('aria-expanded', 'false');
          return;
        }
        status.textContent = drawer.dataset.sizeLoading;
        setBusy(true);
        try {
          const module = await loadSizeModule();
          const handle = item.handle || new URL(item.url, location.origin).pathname.split('/products/')[1]?.split('/')[0];
          if (!handle) throw new Error('Missing product');
          if (!products.has(handle)) {
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Unable to load sizes');
            products.set(handle, await response.json());
          }
          const variants = module.sizeVariants(item, products.get(handle));
          if (!variants.length) throw new Error('No sizes found');
          panel.innerHTML = `<div class="minimal-cart-drawer__size-options" role="group" aria-label="${escapeHtml(drawer.dataset.sizeLabel)}">${variants.map((variant) => `<button class="minimal-cart-drawer__size-option" type="button" data-cart-size-value="${variant.id}" data-size-unavailable="${String(!variant.available)}" aria-pressed="${String(Number(variant.id) === Number(item.variant_id))}" aria-label="${escapeHtml(drawer.dataset.sizeLabel)}: ${escapeHtml(variant.label)}${variant.available ? '' : ` — ${escapeHtml(drawer.dataset.sizeUnavailable)}`}"${variant.available ? '' : ' disabled'}>${escapeHtml(variant.label)}</button>`).join('')}</div>`;
          editSize.setAttribute('aria-expanded', 'true');
          status.textContent = '';
        } catch { status.textContent = drawer.dataset.sizeError; }
        finally {
          setBusy(false);
          if (!drawer.hidden && !drawer.inert) (panel.querySelector('[aria-pressed="true"]:not(:disabled)') || panel.querySelector('button:not(:disabled)') || editSize).focus({ preventScroll: true });
        }
        return;
      }
      if (sizeChoice) {
        const item = latestCart?.items.find((line) => line.key === sizeChoice.closest('[data-cart-line]')?.dataset.cartLine);
        const variantId = Number(sizeChoice.dataset.cartSizeValue);
        if (!item || !variantId || sizeChoice.dataset.sizeUnavailable === 'true' || Number(item.variant_id) === variantId) return;
        let focusTarget = sizeChoice;
        setBusy(true);
        status.textContent = drawer.dataset.sizeSaving;
        try {
          const module = await loadSizeModule();
          const updated = await module.replaceSize({ root, item, variantId });
          render(updated);
          status.textContent = '';
          const replacement = updated.items.find((line) => Number(line.variant_id) === variantId);
          focusTarget = [...content.querySelectorAll('[data-cart-line]')].find((article) => article.dataset.cartLine === replacement?.key)?.querySelector('[data-cart-edit-size]');
        } catch (error) {
          try { await getCart(); } catch {}
          status.textContent = error.partial ? drawer.dataset.sizePartial : drawer.dataset.sizeError;
          if (!focusTarget?.isConnected) focusTarget = [...content.querySelectorAll('[data-cart-line]')].find((article) => article.dataset.cartLine === item.key)?.querySelector('[data-cart-edit-size]');
        } finally {
          window.dispatchEvent(new Event('minimal:cart-updated'));
          setBusy(false);
          if (!drawer.hidden && !drawer.inert) (focusTarget || drawer.querySelector('.minimal-cart-drawer__close')).focus({ preventScroll: true });
        }
        return;
      }
      const recommendationsToggle = event.target.closest('[data-recommendations-toggle]');
      if (recommendationsToggle) {
        const section = recommendationsToggle.closest('.minimal-cart-drawer__recommendations');
        recommendationsCollapsed = section.classList.toggle('is-collapsed');
        recommendationsToggle.setAttribute('aria-expanded', String(!recommendationsCollapsed));
        return;
      }

      const change = event.target.closest('[data-cart-change]');
      const add = event.target.closest('[data-recommendation-add]');
      if (!change && !add) return;
      event.preventDefault();
      setBusy(true);
      status.textContent = '';
      try {
        if (change) {
          const response = await fetch(`${root}cart/change.js`, {
            body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
          if (!response.ok) throw new Error('Unable to update cart');
        }
        if (add) {
          const response = await fetch(`${root}cart/add.js`, {
            body: JSON.stringify({ id: Number(add.dataset.recommendationAdd), quantity: 1 }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
          if (!response.ok) throw new Error('Unable to add item');
        }
        await getCart();
        window.dispatchEvent(new Event('minimal:cart-updated'));
      } catch (error) {
        if (latestCart) render(latestCart);
        status.textContent = drawer.dataset.updateError;
      } finally {
        setBusy(false);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["minimal-cookie-banner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cookie-banner]').forEach((banner) => {
    const manageButton = banner.querySelector('[data-cookie-manage]');
    const acceptButton = banner.querySelector('[data-cookie-accept]');
    const declineButton = banner.querySelector('[data-cookie-decline]');
    const saveButton = banner.querySelector('[data-cookie-save]');
    const preferences = banner.querySelector('[data-cookie-preferences]');
    const preferenceInput = banner.querySelector('[data-cookie-preferences-input]');
    const analyticsInput = banner.querySelector('[data-cookie-analytics-input]');
    const marketingInput = banner.querySelector('[data-cookie-marketing-input]');
    const responseStorageKey = 'minimal-cookie-banner-response-v1';

    const announceState = () => {
      document.dispatchEvent(new CustomEvent('minimal:cookie-banner-state', {
        detail: { visible: !banner.hidden }
      }));
    };
    const hideBanner = () => {
      banner.hidden = true;
      announceState();
    };
    const hasAnswer = (value) => value === 'yes' || value === 'no';

    const hasLocalResponse = () => {
      try {
        return window.localStorage.getItem(responseStorageKey) === 'saved';
      } catch (error) {
        return false;
      }
    };

    const rememberResponse = () => {
      try {
        window.localStorage.setItem(responseStorageKey, 'saved');
      } catch (error) {
        return;
      }
    };

    const captureConsent = (consent) => {
      const privacy = window.Shopify?.customerPrivacy;
      /* Store only that the visitor answered. Shopify remains the source of
         truth for the consent choices; this prevents a visual banner loop if
         its API initialises again during storefront navigation. */
      rememberResponse();
      hideBanner();
      privacy?.setTrackingConsent?.(consent, hideBanner);
    };

    const showWhenNeeded = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy) return;

      const visitorConsent = privacy.currentVisitorConsent?.() || {};
      const hasRecordedChoice = [visitorConsent.preferences, visitorConsent.analytics, visitorConsent.marketing].some(hasAnswer);
      const requiredByRegion = privacy.shouldShowBanner?.() === true;

      banner.hidden = hasLocalResponse() || !(requiredByRegion || !hasRecordedChoice);
      announceState();
    };

    const initialisePrivacyApi = () => {
      if (window.Shopify?.customerPrivacy) {
        showWhenNeeded();
        return;
      }

      if (!window.Shopify?.loadFeatures) {
        announceState();
        return;
      }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) {
          showWhenNeeded();
        } else {
          announceState();
        }
      });
    };

    manageButton?.addEventListener('click', () => {
      const current = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
      preferenceInput.checked = current.preferences === 'yes';
      analyticsInput.checked = current.analytics === 'yes';
      marketingInput.checked = current.marketing === 'yes';
      preferences.hidden = false;
      manageButton.hidden = true;
    });

    acceptButton?.addEventListener('click', () => captureConsent({ preferences: true, analytics: true, marketing: true }));
    declineButton?.addEventListener('click', () => captureConsent({ preferences: false, analytics: false, marketing: false }));
    saveButton?.addEventListener('click', () => captureConsent({
      preferences: preferenceInput.checked,
      analytics: analyticsInput.checked,
      marketing: marketingInput.checked
    }));

    initialisePrivacyApi();
  });
  } catch(e) { console.error(e); }
})();

})();
